import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { UpdateBadgeRequest } from "@shopexperts/legacy-api";

export function useUpdateBadge() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationFn: (params: { 
      badgeId: number; 
      data: UpdateBadgeRequest
    }) => {
      return api.admin.badges.updateBadge({ 
        params: { badge: params.badgeId }, 
        body: params.data 
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'badges'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'badge', variables.badgeId] });
      toaster.create({
        title: "Badge updated successfully",
        type: "success",
      });
    },
    onError: (error) => {
      toaster.create({
        title: "Failed to update badge",
        description: error.message || "An error occurred",
        type: "error",
      });
      console.error('[useUpdateBadge] Error:', error);
    },
  });

  return { mutate, mutateAsync, isPending, error };
}

export default useUpdateBadge;

